import { Integration } from "../integration";
/**
 * Entidad AccountIntegration
 * Contiene información de la integración y sus credenciales.
 */

export enum AccountIntegrationStatus {
	ACTIVE = 'ACTIVE',
	INACTIVE = 'INACTIVE',
	BETA = 'BETA',
	DEPRECATED = 'DEPRECATED',
}
export enum AccountIntegrationConnectionStatus {
	CONNECTED = 'CONNECTED',
	DISCONNECTED = 'DISCONNECTED',
	ERROR = 'ERROR',
	WARNING = 'WARNING',
}

export enum AccountIntegrationEnvironment {
	PRODUCTION = 'PRODUCTION',
	DEVELOPMENT = 'DEVELOPMENT',
}

export interface AccountIntegration {
	id: string;
	accountId: string;
	integrationId: string;
	settingsProduction: Object | null;
	settingsDevelopment: Object | null;
	environment: AccountIntegrationEnvironment;
	productionStatus: AccountIntegrationConnectionStatus;
	developmentStatus: AccountIntegrationConnectionStatus;
	status: AccountIntegrationStatus;
	demo: boolean;
	createdAt: Date;
	updatedAt: Date;
	deletedAt?: Date | null;

	integration: Integration;

	settings: Record<string, any>; // settings for requested environment
}